document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.new-product-showcase');
  if (!section) return;

  const grid = section.querySelector('.new-product-showcase-grid');
  const prevBtn = section.querySelector('.prev-btn');
  const nextBtn = section.querySelector('.next-btn');
  const cards = section.querySelectorAll('.new-product-showcase-card');

  let currentIndex = 0;

  function getCardStep() {
    if (!cards.length) return 0;
    if (cards.length > 1) {
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }
    const gridStyles = window.getComputedStyle(grid);
    const gap = parseFloat(gridStyles.columnGap || gridStyles.gap || 0);
    return cards[0].getBoundingClientRect().width + gap;
  }

  // Only show navigation on desktop and when more than 4 products
  function updateNavigationVisibility() {
    if (window.innerWidth >= 1024) {
      if (cards.length > 4) {
        prevBtn.classList.add('show');
        nextBtn.classList.add('show');
        grid.classList.add('scrollable');
        updateButtonStates();
      } else {
        prevBtn.classList.remove('show');
        nextBtn.classList.remove('show');
        grid.classList.remove('scrollable');
      }
    } else {
      prevBtn.classList.remove('show');
      nextBtn.classList.remove('show');
      grid.classList.remove('scrollable');
    }
  }

  // Update button disabled states based on current index
  function updateButtonStates() {
    if (!grid || cards.length <= 4) return;

    const maxIndex = cards.length - 4;

    // Disable prev button if at start
    if (currentIndex <= 0) {
      prevBtn.disabled = true;
    } else {
      prevBtn.disabled = false;
    }

    // Disable next button if at end (showing last 4 cards)
    if (currentIndex >= maxIndex) {
      nextBtn.disabled = true;
    } else {
      nextBtn.disabled = false;
    }
  }

  // Scroll to specific card index (showing 4 cards starting from that index)
  function scrollToIndex(index) {
    if (!grid || cards.length <= 4) return;

    const step = getCardStep();
    const scrollAmount = step * index;

    grid.scrollTo({ left: scrollAmount, behavior: 'smooth' });
    currentIndex = index;
    updateButtonStates();
  }

  // Scroll one card (previous)
  function scrollPrev() {
    if (currentIndex > 0) {
      scrollToIndex(currentIndex - 1);
    }
  }

  // Scroll one card (next)
  function scrollNext() {
    const maxIndex = cards.length - 4;
    if (currentIndex < maxIndex) {
      scrollToIndex(currentIndex + 1);
    }
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', scrollPrev);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', scrollNext);
  }

  if (grid) {
    let scrollTimer;
    grid.addEventListener('scroll', () => {
      if (!cards.length) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const step = getCardStep();
        if (!step) return;
        const index = Math.round(grid.scrollLeft / step);
        currentIndex = Math.max(0, Math.min(index, cards.length - 4));
        updateButtonStates();
      }, 60);
    });
  }

  // Initialize on load
  updateNavigationVisibility();

  // Update on window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      currentIndex = 0;
      if (grid) {
        grid.scrollTo({ left: 0, behavior: 'auto' });
      }
      updateNavigationVisibility();
    }, 250);
  });

  // Header reveal animation (replays whenever section re-enters viewport)
  const subtitleWrap = section.querySelector('.new-product-showcase-subtitle-wrap');
  const title = section.querySelector('.new-product-showcase-title');
  let headerVisible = false;

  if (subtitleWrap) subtitleWrap.classList.add('is-reveal-ready');
  if (title) title.classList.add('is-reveal-ready');

  function hideHeader() {
    if (subtitleWrap) subtitleWrap.classList.remove('is-visible');
    if (title) title.classList.remove('is-visible');
    headerVisible = false;
  }

  function revealHeader() {
    if (headerVisible) return;
    headerVisible = true;
    if (subtitleWrap) subtitleWrap.classList.add('is-visible');
    if (title) {
      setTimeout(() => {
        title.classList.add('is-visible');
      }, 120);
    }
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            revealHeader();
          } else {
            hideHeader();
          }
        });
      },
      { threshold: 0.25 }
    );
    observer.observe(section);
  } else {
    revealHeader();
  }
});